module.exports = __webpack_public_path__ + "static/ma-9-306f398bc8293b488a835de8381ea41e.png";